import { combineReducers } from "redux";
import homeReducer from "../home/reducers";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const homeReducerConfig = {
  key: "home",
  storage,
  version: 1,
};

const rootReducer = combineReducers({
  home: persistReducer(homeReducerConfig, homeReducer),
});

export default rootReducer;
